import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';
import { isReadable, useAutoTransitioningColors } from '@atlassian/color-picker';
import { useProductDependencies } from '@atlassian/company-hub-common';

import type { LinksMenuExtensionActions } from '../../../controllers/use-links-menu-parameters-and-actions';
import type { LinksMenuParameters } from '../../../types';

import { AlignmentConfig } from './alignment-config';
import { BackgroundConfig } from './background-config';
import { TextConfig } from './text-config';

const stylesTabStyles = xcss({
	width: '100%',
});

export type StylesTabProps = {
	actions: LinksMenuExtensionActions;
	parameters: LinksMenuParameters;
};

export const StylesTab = ({ parameters, actions }: StylesTabProps): React.JSX.Element => {
	const { styles } = parameters ?? {};
	const {
		updateBorder,
		updateBorderColor,
		updateCornerRadius,
		updateCornerStyle,
		updateFillColor,
		updateHighlightColor,
		updateTextColor,
	} = actions;

	const isReadableFillColor = (color: string) => isReadable(color, styles.textColor);
	const isReadableTextColor = (color: string) => isReadable(color, styles.fillColor);

	const { branding } = useProductDependencies();

	useAutoTransitioningColors(
		styles.fillColor,
		isReadableTextColor,
		styles.textColor,
		updateTextColor,
		branding?.defaultParameters,
	);

	return (
		<Flex direction="column" xcss={stylesTabStyles}>
			<AlignmentConfig
				updateAlignment={actions.updateAlignment}
				alignment={parameters.styles.alignment}
			/>
			<BackgroundConfig
				border={styles.border}
				updateBorder={updateBorder}
				borderColor={styles.borderColor}
				updateBorderColor={updateBorderColor}
				fillColor={styles.fillColor}
				updateFillColor={updateFillColor}
				cornerStyle={styles.cornerStyle}
				updateCornerStyle={updateCornerStyle}
				cornerRadius={styles.cornerRadius}
				updateCornerRadius={updateCornerRadius}
				isReadableFillColor={isReadableFillColor}
			/>
			<TextConfig
				highlightColor={styles.highlightColor}
				updateHighlightColor={updateHighlightColor}
				textColor={styles.textColor}
				updateTextColor={updateTextColor}
				isReadableTextColor={isReadableTextColor}
			/>
		</Flex>
	);
};
